// AUTO-GENERIERT aus hilfe-artikel-global.seed.json — nicht von Hand editieren.
export interface HelpArticle {
  id: string; slug: string; category: string; title: string;
  keywords: string[]; relates: string[]; related: string[]; body: string;
}

export const HELP_ARTICLES: HelpArticle[] = [
  {
    "id": "HA-01",
    "slug": "erste-schritte",
    "category": "Erste Schritte",
    "title": "Anmelden und erste Schritte",
    "keywords": [
      "login",
      "anmelden",
      "start",
      "beginnen",
      "einstieg"
    ],
    "relates": [
      "S-01",
      "S-02"
    ],
    "related": [
      "HA-02",
      "HA-04",
      "HA-27"
    ],
    "body": "**Kurz:** Nach der Anmeldung landest du im Dashboard. Hier wartest du auf Anrufe, siehst dein Team und deine Stelen.\n**So geht's:** 1) Anmelden. 2) Oben den **Status** auf „Verfügbar\" setzen, damit dir Anrufe zugestellt werden. 3) Einmal **Kamera & Mikrofon** in den Einstellungen prüfen. 4) Auf eingehende Anrufe warten.\n**Gut zu wissen:** Hilfe findest du jederzeit über **⌘K → „Hilfe\"** oben in der Suchleiste."
  },
  {
    "id": "HA-02",
    "slug": "status-setzen",
    "category": "Erste Schritte",
    "title": "Verfügbarkeit und Status setzen",
    "keywords": [
      "status",
      "verfügbar",
      "pause",
      "nachbearbeitung",
      "besetzt",
      "verfügbarkeit"
    ],
    "relates": [
      "H-03"
    ],
    "related": [
      "HA-03",
      "HA-35"
    ],
    "body": "**Kurz:** Dein Status steuert, ob dir Videoanrufe zugestellt werden.\n**Die Status:** **Verfügbar** (du bekommst Anrufe) · **Pause** (keine Anrufe) · **Nachbearbeitung** (nach einem Gespräch, keine Anrufe) · **Besetzt** (du bist im Gespräch).\n**So geht's:** Oben im Kopf auf das gewünschte Segment klicken.\n**Gut zu wissen:** Gibt es ein **Telefon**-Segment, ist deine Telefonanlage gekoppelt — es schaltet automatisch, sobald du telefonierst (siehe HA-35)."
  },
  {
    "id": "HA-03",
    "slug": "routing-gruppen",
    "category": "Erste Schritte",
    "title": "Wie Anrufe zu dir kommen (Routing & Gruppen)",
    "keywords": [
      "routing",
      "gruppe",
      "verteilung",
      "anruf zustellung",
      "warteschlange"
    ],
    "relates": [
      "L-02"
    ],
    "related": [
      "HA-02",
      "HA-18"
    ],
    "body": "**Kurz:** Anrufe von den Stelen werden anhand von **Gruppen/Themen** an verfügbare Berater verteilt.\n**So geht's:** Du musst nichts tun außer „Verfügbar\" zu sein. In welchen Gruppen du bist, legt dein Kunden-Admin fest.\n**Gut zu wissen:** Dein Team und dessen Status siehst du links im **Roster**. Mandantenspezifische Details zu euren Gruppen stehen ggf. unter „Bei {Mandant}\"."
  },
  {
    "id": "HA-04",
    "slug": "suche-befehle",
    "category": "Erste Schritte",
    "title": "Hilfe finden, Suche und Befehle (⌘K)",
    "keywords": [
      "suche",
      "hilfe",
      "befehle",
      "kommando",
      "cmdk",
      "tastenkürzel",
      "shortcuts"
    ],
    "relates": [
      "H-08"
    ],
    "related": [
      "HA-01"
    ],
    "body": "**Kurz:** Über **Suche & Aktionen** (⌘K) findest du Funktionen, Personen — und alle Hilfe-Artikel.\n**So geht's:** ⌘K (bzw. Klick auf die Suchleiste) → Begriff eintippen → in der Sektion **„Hilfe\"** den passenden Artikel öffnen.\n**Gut zu wissen:** Viele Elemente bieten ein **„?\"**, das direkt den passenden Hilfe-Artikel öffnet."
  },
  {
    "id": "HA-05",
    "slug": "anruf-annehmen",
    "category": "Anruf",
    "title": "Anruf annehmen oder ablehnen",
    "keywords": [
      "anruf",
      "annehmen",
      "ablehnen",
      "eingehend",
      "klingeln"
    ],
    "relates": [
      "IC-01",
      "IC-04"
    ],
    "related": [
      "HA-06",
      "HA-07"
    ],
    "body": "**Kurz:** Bei einem eingehenden Ruf erscheint eine Karte mit Herkunft (Stele, Gruppe) und Wartezeit.\n**So geht's:** **Annehmen** mit der **Enter**-Taste, **Ablehnen** mit **Esc** — oder die Buttons auf der Karte nutzen.\n**Gut zu wissen:** Die Karte zeigt, welche Stele anruft und wie lange der Gast schon wartet."
  },
  {
    "id": "HA-06",
    "slug": "anruf-abdocken",
    "category": "Anruf",
    "title": "Anruf abdocken (schwebendes Fenster)",
    "keywords": [
      "abdocken",
      "pip",
      "schwebend",
      "fenster",
      "bild im bild",
      "multitasking"
    ],
    "relates": [
      "IC-06",
      "S-06"
    ],
    "related": [
      "HA-05",
      "HA-08"
    ],
    "body": "**Kurz:** Du kannst den Anruf (auch den eingehenden Ruf) in ein kleines schwebendes Fenster auslagern, das sichtbar bleibt, während du in anderen Programmen arbeitest.\n**So geht's:** Auf **„Abdocken\"** tippen. Das Fenster hat eine reduzierte Steuerleiste (Stummschalten, Auflegen, Tauschen, Scan, Signieren).\n**Gut zu wissen:** Schließe das schwebende Fenster, um wieder in die volle Ansicht zurückzukehren."
  },
  {
    "id": "HA-07",
    "slug": "klingelton-waehlen",
    "category": "Anruf",
    "title": "Klingelton wählen",
    "keywords": [
      "klingelton",
      "ton",
      "sound",
      "klingeln",
      "audio"
    ],
    "relates": [
      "SET-01",
      "IC-05"
    ],
    "related": [
      "HA-34"
    ],
    "body": "**Kurz:** Du kannst aus mehreren Klingeltönen wählen oder den Ton ausschalten.\n**So geht's:** **Einstellungen → Allgemein → Audio-Feedback → Klingelton-Auswahl**. Mit **„Anhören\"** vorhören.\n**Gut zu wissen:** Die Anruf-Karte zeigt den gewählten Ton an („Klingelt · …\") bzw. „Stumm\", wenn ausgeschaltet."
  },
  {
    "id": "HA-08",
    "slug": "buehne-eigenbild",
    "category": "Im Gespräch",
    "title": "Die Gesprächs-Bühne, Eigenbild und Tauschen",
    "keywords": [
      "bühne",
      "eigenbild",
      "self view",
      "vorschau",
      "tauschen",
      "swap",
      "video"
    ],
    "relates": [
      "ST-01",
      "ST-02",
      "ST-03"
    ],
    "related": [
      "HA-10",
      "HA-22"
    ],
    "body": "**Kurz:** Groß siehst du den Gast/die Stele, klein dein Eigenbild.\n**So geht's:** Klick auf das **Eigenbild** tauscht es mit dem großen Bild — praktisch, um z. B. die Dokumentenkamera groß zu zeigen.\n**Gut zu wissen:** Das Eigenbild lässt sich ausblenden und über „Vorschau wieder einschalten\" zurückholen."
  },
  {
    "id": "HA-09",
    "slug": "mikrofon",
    "category": "Im Gespräch",
    "title": "Mikrofon stummschalten und Mikrofon wählen",
    "keywords": [
      "mikrofon",
      "stumm",
      "mute",
      "ton",
      "headset",
      "audioquelle"
    ],
    "relates": [
      "CB-01",
      "CB-02"
    ],
    "related": [
      "HA-11",
      "HA-28"
    ],
    "body": "**Kurz:** Mit dem Mikrofon-Button schaltest du dich stumm/laut.\n**So geht's:** Button = stummschalten. Der **kleine Pfeil** daneben öffnet die **Mikrofon-Auswahl** (z. B. Headset statt eingebautem Mikro).\n**Gut zu wissen:** Stumm bleibt aktiv, bis du es wieder aufhebst — auch über Gespräche hinweg gut sichtbar."
  },
  {
    "id": "HA-10",
    "slug": "kamera-umschalten",
    "category": "Im Gespräch",
    "title": "Kamera ein/aus und Kamera umschalten",
    "keywords": [
      "kamera",
      "dokumentenkamera",
      "umschalten",
      "wechseln",
      "video aus",
      "quelle"
    ],
    "relates": [
      "CB-03",
      "CB-04"
    ],
    "related": [
      "HA-08",
      "HA-21"
    ],
    "body": "**Kurz:** Du kannst deine Kamera ein-/ausschalten und zwischen mehreren Kameras wechseln.\n**So geht's:** Button = Kamera an/aus. Der **kleine Pfeil** daneben öffnet die **Kamera-Auswahl** — so wechselst du z. B. zwischen **deinem Gesicht** und einer **Dokumentenkamera**.\n**Gut zu wissen:** Zum Zeigen von Unterlagen die Dokumentenkamera wählen und ggf. mit „Tauschen\" groß darstellen."
  },
  {
    "id": "HA-11",
    "slug": "lautsprecher",
    "category": "Im Gespräch",
    "title": "Lautsprecher und Lautstärke",
    "keywords": [
      "lautsprecher",
      "lautstärke",
      "ton",
      "ausgabe",
      "wiedergabe"
    ],
    "relates": [
      "CB-05",
      "CB-06"
    ],
    "related": [
      "HA-09",
      "HA-28"
    ],
    "body": "**Kurz:** Über den Lautsprecher-Button regelst du Wiedergabe/Lautstärke.\n**So geht's:** Button = Wiedergabe stumm/laut. Der **Pfeil** daneben wählt das **Ausgabegerät** (sofern dein Browser das unterstützt).\n**Gut zu wissen:** Unterstützt der Browser keine Geräteauswahl, stellst du die Ausgabe im Betriebssystem ein."
  },
  {
    "id": "HA-12",
    "slug": "virtueller-hintergrund",
    "category": "Im Gespräch",
    "title": "Virtueller Hintergrund",
    "keywords": [
      "hintergrund",
      "weichzeichnen",
      "blur",
      "datenschutz",
      "virtuell"
    ],
    "relates": [
      "CB-07"
    ],
    "related": [
      "HA-08"
    ],
    "body": "**Kurz:** Du kannst deinen Hintergrund weichzeichnen oder durch ein Bild ersetzen.\n**So geht's:** Hintergrund-Button → **Aus**, **Weichzeichnen** (mehrere Stufen) oder ein **Preset-Bild** wählen.\n**Gut zu wissen:** Weichzeichnen schützt die Privatsphäre des Arbeitsplatzes, ohne abzulenken."
  },
  {
    "id": "HA-13",
    "slug": "bildschirm-teilen",
    "category": "Im Gespräch",
    "title": "Bildschirm teilen",
    "keywords": [
      "bildschirm",
      "teilen",
      "screen share",
      "präsentieren",
      "freigabe"
    ],
    "relates": [
      "CB-08"
    ],
    "related": [
      "HA-10"
    ],
    "body": "**Kurz:** Du kannst dem Gast deinen Bildschirm zeigen.\n**So geht's:** Button „Bildschirm teilen\" → Fenster/Bildschirm auswählen → freigeben. Erneut tippen beendet die Freigabe.\n**Gut zu wissen:** Teile gezielt ein einzelnes Fenster, um nichts Vertrauliches einzublenden."
  },
  {
    "id": "HA-14",
    "slug": "uebersetzung",
    "category": "Im Gespräch",
    "title": "Übersetzung und Untertitel",
    "keywords": [
      "übersetzung",
      "untertitel",
      "sprache",
      "dolmetschen",
      "translation"
    ],
    "relates": [
      "CB-09",
      "SET-01"
    ],
    "related": [
      "HA-34"
    ],
    "body": "**Kurz:** Steuerung für Live-Übersetzung/Untertitel im Gespräch.\n**So geht's:** Übersetzungs-Button → Stele-Sprache und Sprachauswahl beim Kunden einstellen, optional Hinweis-Nachricht senden. Untertitel-Größe in **Einstellungen → Allgemein**.\n**Gut zu wissen:** Verfügbarkeit/Umfang kann je Mandant unterschiedlich sein (siehe „Bei {Mandant}\")."
  },
  {
    "id": "HA-15",
    "slug": "aufzeichnung",
    "category": "Im Gespräch",
    "title": "Gespräch aufzeichnen (mit Einwilligung)",
    "keywords": [
      "aufzeichnung",
      "recording",
      "rec",
      "einwilligung",
      "consent",
      "mitschnitt"
    ],
    "relates": [
      "CB-10",
      "ST-05"
    ],
    "related": [
      "HA-25"
    ],
    "body": "**Kurz:** Beratungsgespräche können — nur mit Einwilligung — aufgezeichnet werden.\n**So geht's:** Aufzeichnen-Button → **Thema wählen** und die **Einwilligung des Gastes bestätigen** → Aufzeichnung startet. Beide Seiten sehen einen Indikator („REC\" bzw. eine Hinweis-Pille auf der Stele).\n**Gut zu wissen:** Aufzeichnung ist nur für bestimmte, beratungspflichtige Themen vorgesehen. Die genauen Regeln legt dein Mandant fest (siehe „Bei {Mandant}\")."
  },
  {
    "id": "HA-16",
    "slug": "teilnehmer-einladen",
    "category": "Im Gespräch",
    "title": "Weitere Person einladen",
    "keywords": [
      "einladen",
      "teilnehmer",
      "experte",
      "hinzufügen",
      "dritter",
      "mesh"
    ],
    "relates": [
      "CB-11"
    ],
    "related": [
      "HA-18",
      "HA-20"
    ],
    "body": "**Kurz:** Du kannst eine weitere Person (z. B. eine:n Spezialist:in) ins Gespräch holen.\n**So geht's:** Einladungs-Button → Einladung/Link erzeugen und teilen. Die Person tritt dem Gespräch bei.\n**Gut zu wissen:** Zum Entfernen siehe „Experten trennen\" (HA-20)."
  },
  {
    "id": "HA-17",
    "slug": "dokument-signieren",
    "category": "Im Gespräch",
    "title": "Dokument signieren lassen",
    "keywords": [
      "signieren",
      "unterschrift",
      "signatur",
      "pdf",
      "unterschreiben"
    ],
    "relates": [
      "CB-12"
    ],
    "related": [
      "HA-21",
      "HA-23"
    ],
    "body": "**Kurz:** Du kannst ein PDF an die Stele schicken, damit der Gast dort unterschreibt.\n**So geht's:** Signatur-Button → Dokument auswählen/senden → der Gast unterschreibt an der Stele → das signierte PDF kommt zurück und landet in der Session-Ablage.\n**Gut zu wissen:** Der Dokumenten-/Ablage-Workflow kann mandantenspezifisch sein (siehe „Bei {Mandant}\")."
  },
  {
    "id": "HA-18",
    "slug": "anruf-weiterleiten",
    "category": "Im Gespräch",
    "title": "Anruf weiterleiten",
    "keywords": [
      "weiterleiten",
      "übergeben",
      "transfer",
      "kollege",
      "gruppe"
    ],
    "relates": [
      "CB-13",
      "L-02"
    ],
    "related": [
      "HA-03",
      "HA-16"
    ],
    "body": "**Kurz:** Du kannst ein laufendes Gespräch an eine:n Kolleg:in oder eine Gruppe übergeben.\n**So geht's:** Weiterleiten-Button → Ziel (Person/Gruppe) wählen → übergeben.\n**Gut zu wissen:** Wer verfügbar ist, siehst du am Status im Roster (links)."
  },
  {
    "id": "HA-19",
    "slug": "auflegen",
    "category": "Im Gespräch",
    "title": "Auflegen und Nachbearbeitung",
    "keywords": [
      "auflegen",
      "beenden",
      "nachbearbeitung",
      "wrapup",
      "ende"
    ],
    "relates": [
      "CB-14",
      "S-07"
    ],
    "related": [
      "HA-02"
    ],
    "body": "**Kurz:** Mit „Auflegen\" beendest du das Gespräch.\n**So geht's:** Auflegen-Button (oder **⌘H**). Danach kannst du in den Status **Nachbearbeitung** wechseln, um das Gespräch in Ruhe abzuschließen, bevor der nächste Anruf kommt.\n**Gut zu wissen:** „Auflegen\" ist bewusst abgesetzt, damit es nicht versehentlich getroffen wird."
  },
  {
    "id": "HA-20",
    "slug": "experten-trennen",
    "category": "Im Gespräch",
    "title": "Teilnehmer/Experten trennen",
    "keywords": [
      "trennen",
      "entfernen",
      "experte",
      "teilnehmer",
      "kick"
    ],
    "relates": [
      "CB-15"
    ],
    "related": [
      "HA-16"
    ],
    "body": "**Kurz:** Eine zusätzlich eingeladene Person kannst du wieder aus dem Gespräch entfernen.\n**So geht's:** „Experten trennen\" wählen → der/die zusätzliche Teilnehmer:in verlässt das Gespräch; du und der Gast bleiben verbunden.\n**Gut zu wissen:** Sichtbar nur, wenn tatsächlich eine weitere Person im Gespräch ist."
  },
  {
    "id": "HA-21",
    "slug": "scannen",
    "category": "Dokumente",
    "title": "Dokument scannen (hochauflösend)",
    "keywords": [
      "scan",
      "scannen",
      "snapshot",
      "dokument",
      "foto",
      "aufnahme",
      "ausweis"
    ],
    "relates": [
      "INS-04",
      "INS-06"
    ],
    "related": [
      "HA-22",
      "HA-23"
    ],
    "body": "**Kurz:** Du kannst ein hochauflösendes Einzelbild (Scan) aus der Stele-Kamera auslösen — ohne das laufende Bild zu stören.\n**So geht's:** Im Inspection-/Detailfenster den **Scan-Button** (Flachbett-Scanner-Symbol) drücken. Das Ergebnis erscheint im **Snapshot-Viewer** und wird in der **Session-Ablage** abgelegt.\n**Gut zu wissen:** Der Scan nutzt das hochauflösende Master-Bild der Stele — daher deutlich mehr Details als im normalen Livebild."
  },
  {
    "id": "HA-22",
    "slug": "zoom-inspection",
    "category": "Dokumente",
    "title": "In das Stele-Bild zoomen und navigieren",
    "keywords": [
      "zoom",
      "inspection",
      "ausschnitt",
      "navigieren",
      "detail",
      "lupe",
      "roi"
    ],
    "relates": [
      "INS-01",
      "INS-02",
      "INS-03",
      "INS-05"
    ],
    "related": [
      "HA-21",
      "HA-08"
    ],
    "body": "**Kurz:** Du kannst in das hochauflösende Kamerabild der Stele hineinzoomen und den Ausschnitt verschieben.\n**So geht's:** Im Detailfenster mit dem **Zoom-Slider** vergrößern und mit dem **Steuerkreuz** (Hoch/Runter/Links/Rechts) oder per Ziehen den Ausschnitt bewegen.\n**Gut zu wissen:** Es wird ein echter Ausschnitt aus dem hochauflösenden Bild gewählt — nicht das Livebild hochskaliert. Das normale Gesprächsbild läuft ungestört weiter."
  },
  {
    "id": "HA-23",
    "slug": "ablage",
    "category": "Dokumente",
    "title": "Session-Ablage und Ordnerziele",
    "keywords": [
      "ablage",
      "dokumente",
      "ordner",
      "speichern",
      "session",
      "scans"
    ],
    "relates": [
      "L-03",
      "SET-04"
    ],
    "related": [
      "HA-21",
      "HA-17"
    ],
    "body": "**Kurz:** Im Gespräch erfasste Scans und Unterschriften landen in der **Session-Ablage** (links unten, neueste oben).\n**So geht's:** Dokument in der Ablage anklicken, um es zu öffnen/weiterzuverarbeiten. Ablageziele/Ordner stellst du unter **Einstellungen → Ablage & Ordner** ein.\n**Gut zu wissen:** Wo Dokumente final hingehören, kann mandantenspezifisch geregelt sein (siehe „Bei {Mandant}\")."
  },
  {
    "id": "HA-24",
    "slug": "verbindung-verschluesselung",
    "category": "Verbindung & Sicherheit",
    "title": "Verbindungsqualität und Verschlüsselung verstehen",
    "keywords": [
      "verbindung",
      "qualität",
      "signal",
      "balken",
      "verschlüsselung",
      "badge",
      "rtt"
    ],
    "relates": [
      "ST-04"
    ],
    "related": [
      "HA-25",
      "HA-33"
    ],
    "body": "**Kurz:** Das Badge in der Gesprächs-Topbar zeigt **Verbindungsqualität** (Signalbalken) und **Verschlüsselung**.\n**So geht's:** Auf das Badge klicken — **links** Telemetrie (Transport, Laufzeit/RTT, Bandbreite), **rechts** der Verschlüsselungs-Status.\n**Gut zu wissen:** Mehr leuchtende Balken = bessere Verbindung. Bei „Schwacher Empfang\" siehe HA-33."
  },
  {
    "id": "HA-25",
    "slug": "datenschutz-e2ee",
    "category": "Verbindung & Sicherheit",
    "title": "Datenschutz: Was der Server (nicht) sieht",
    "keywords": [
      "datenschutz",
      "e2ee",
      "verschlüsselung",
      "privatsphäre",
      "server",
      "sicherheit"
    ],
    "relates": [
      "ST-04"
    ],
    "related": [
      "HA-24",
      "HA-15"
    ],
    "body": "**Kurz:** Audio, Video und Inhalte (Scans, Unterschriften, Kartendaten) laufen **direkt und Ende-zu-Ende-verschlüsselt** zwischen den Geräten.\n**Details:** Der Server vermittelt nur den Verbindungsaufbau und Steuer-/Status­signale — er sieht **keine** Gesprächsinhalte. Läuft die Verbindung über einen Relay (TURN), sieht dieser nur verschlüsselte Daten.\n**Gut zu wissen:** Für Aufzeichnungen gelten zusätzlich Einwilligung und Regeln (HA-15)."
  },
  {
    "id": "HA-26",
    "slug": "erreichbarkeit",
    "category": "Verbindung & Sicherheit",
    "title": "Erreichbarkeit sicherstellen",
    "keywords": [
      "erreichbarkeit",
      "benachrichtigung",
      "push",
      "wake lock",
      "pwa",
      "glocke",
      "app installieren"
    ],
    "relates": [
      "H-09",
      "SET-02"
    ],
    "related": [
      "HA-01",
      "HA-30"
    ],
    "body": "**Kurz:** Damit dich Anrufe zuverlässig erreichen, sollten die Erreichbarkeits-Mechanismen aktiv sein.\n**So geht's:** Auf das **Glocken-Symbol** klicken → Ampel je Mechanismus prüfen (Benachrichtigungen, Hintergrund-Dienst, Push, Bildschirm-wachhalten, „als App installiert\"). Details/Schalter unter **Einstellungen → Erreichbarkeit**.\n**Gut zu wissen:** „Als App installieren\" (PWA) verbessert Benachrichtigungen und Stabilität."
  },
  {
    "id": "HA-27",
    "slug": "geraete-blockiert",
    "category": "Geräte & Technik",
    "title": "Kamera oder Mikrofon blockiert / nicht vorhanden",
    "keywords": [
      "kamera",
      "mikrofon",
      "blockiert",
      "fehlt",
      "berechtigung",
      "gesperrt",
      "kein gerät"
    ],
    "relates": [
      "H-05",
      "SET-03"
    ],
    "related": [
      "HA-28",
      "HA-29"
    ],
    "body": "**Kurz:** Erscheint oben der rote Hinweis „Kamera/Mikrofon blockiert\" oder „fehlt\", kann die App das Gerät nicht nutzen.\n**So geht's:** Auf den Hinweis klicken (öffnet **Einstellungen → Kamera & Geräte**). Bei **blockiert**: im Browser die Berechtigung für die Seite erlauben. Bei **fehlt**: ein Gerät anschließen/aktivieren.\n**Gut zu wissen:** Der Hinweis erscheint sofort, sobald sich die Berechtigung ändert."
  },
  {
    "id": "HA-28",
    "slug": "geraete-pruefen",
    "category": "Geräte & Technik",
    "title": "Geräte prüfen und Quelle wählen",
    "keywords": [
      "geräte",
      "test",
      "prüfen",
      "kamera",
      "mikrofon",
      "lautstärke",
      "auflösung"
    ],
    "relates": [
      "SET-03"
    ],
    "related": [
      "HA-09",
      "HA-10",
      "HA-11"
    ],
    "body": "**Kurz:** In den Einstellungen kannst du Kamera/Mikrofon testen und Voreinstellungen treffen.\n**So geht's:** **Einstellungen → Kamera & Geräte** → Live-Check ansehen, Auflösung/Lautstärke einstellen, bevorzugte Quellen wählen.\n**Gut zu wissen:** Im Gespräch kannst du Quellen zusätzlich über die Pfeile in der Steuerleiste wechseln (HA-09/10/11)."
  },
  {
    "id": "HA-29",
    "slug": "kamera-belegt",
    "category": "Geräte & Technik",
    "title": "„Kamera wird von anderer App benutzt\" beheben",
    "keywords": [
      "belegt",
      "andere app",
      "in benutzung",
      "notreadable",
      "kamera blockiert app"
    ],
    "relates": [
      "SET-03"
    ],
    "related": [
      "HA-27",
      "HA-28"
    ],
    "body": "**Kurz:** Meldet die App beim Annehmen, die Kamera sei „belegt\", hält ein **anderes Programm** (oder ein anderer Tab) die Kamera.\n**So geht's:** Andere Kamera-Programme schließen (z. B. Windows-Kamera-App, Teams, anderer Browser-Tab) → erneut versuchen bzw. die Seite neu laden.\n**Gut zu wissen:** Dieser Zustand zeigt sich erst beim tatsächlichen Öffnen der Kamera — daher beim Annehmen oder im Geräte-Check."
  },
  {
    "id": "HA-30",
    "slug": "browser-voraussetzungen",
    "category": "Geräte & Technik",
    "title": "Browser und Voraussetzungen",
    "keywords": [
      "browser",
      "voraussetzungen",
      "chrome",
      "edge",
      "system",
      "anforderungen"
    ],
    "relates": [],
    "related": [
      "HA-26",
      "HA-27"
    ],
    "body": "**Kurz:** Die Berater-App läuft am besten in einem aktuellen **Chrome** oder **Edge** am Desktop.\n**So geht's:** Browser aktuell halten, Kamera-/Mikrofon-Berechtigung für die Seite erlauben, idealerweise „als App installieren\" (PWA).\n**Gut zu wissen:** Bei hartnäckigen Geräte-/Verbindungsproblemen hilft oft ein Neuladen der Seite."
  },
  {
    "id": "HA-31",
    "slug": "karte-erkannt",
    "category": "Status & Hinweise",
    "title": "Hinweis „EC-/NFC-Karte erkannt\"",
    "keywords": [
      "ec karte",
      "nfc",
      "karte",
      "kartenleser",
      "erkannt",
      "chip"
    ],
    "relates": [
      "H-06"
    ],
    "related": [
      "HA-25"
    ],
    "body": "**Kurz:** Der kurze Hinweis oben zeigt, dass an der Stele eine Karte gelesen wurde.\n**Gut zu wissen:** Die Kartendaten laufen verschlüsselt im Gesprächskontext; der Server sieht sie nicht (HA-25). Was genau passiert, kann mandantenspezifisch sein."
  },
  {
    "id": "HA-32",
    "slug": "companion-chip",
    "category": "Status & Hinweise",
    "title": "Hinweis „Companion verbunden\"",
    "keywords": [
      "companion",
      "chip",
      "verbunden",
      "terminal server",
      "zweite sitzung"
    ],
    "relates": [
      "H-04"
    ],
    "related": [
      "HA-36"
    ],
    "body": "**Kurz:** Zeigt an, dass deine **Companion-Sitzung** (für die lokale Ablage) verbunden ist.\n**Gut zu wissen:** Mehr dazu unter „Was ist der Companion?\" (HA-36)."
  },
  {
    "id": "HA-33",
    "slug": "schwacher-empfang",
    "category": "Status & Hinweise",
    "title": "Hinweis „Schwacher Empfang\"",
    "keywords": [
      "empfang",
      "verbindung",
      "schwach",
      "instabil",
      "netzwerk",
      "qualität"
    ],
    "relates": [
      "H-07"
    ],
    "related": [
      "HA-24"
    ],
    "body": "**Kurz:** Erscheint, wenn die Verbindung gerade schwach ist.\n**So geht's:** Nach Möglichkeit auf eine stabilere Verbindung wechseln (LAN statt WLAN), bandbreitenhungrige Anwendungen schließen.\n**Gut zu wissen:** Details zur Qualität siehst du im Verbindungs-Badge (HA-24)."
  },
  {
    "id": "HA-34",
    "slug": "darstellung-audio",
    "category": "Einstellungen",
    "title": "Darstellung (Hell/Dunkel) und Audio-Feedback",
    "keywords": [
      "theme",
      "hell",
      "dunkel",
      "darstellung",
      "audio",
      "töne",
      "klingelton"
    ],
    "relates": [
      "SET-01"
    ],
    "related": [
      "HA-07"
    ],
    "body": "**Kurz:** Aussehen und Töne der App passt du in den Einstellungen an.\n**So geht's:** **Einstellungen → Allgemein** → Hell/Dunkel umschalten; unter **Audio-Feedback** Klingelton wählen und Töne für Annehmen/Auflegen/Snapshot ein-/ausschalten.\n**Gut zu wissen:** Untertitel-Größe ebenfalls hier (Bereich Übersetzung)."
  },
  {
    "id": "HA-35",
    "slug": "telefonie-kopplung",
    "category": "Einstellungen",
    "title": "Telefonie-Kopplung (Teams/Webex)",
    "keywords": [
      "telefonie",
      "teams",
      "webex",
      "telefon",
      "kopplung",
      "presence",
      "bitte nicht stören"
    ],
    "relates": [
      "SET-05",
      "H-03b"
    ],
    "related": [
      "HA-02"
    ],
    "body": "**Kurz:** Optional lässt sich dein Telefoniestatus mit der Videoberatung koppeln, damit du nicht gleichzeitig telefonierst und Videoanrufe bekommst.\n**So geht's:** **Einstellungen → Telefonie-Kopplung** → bei Teams bzw. Webex auf „Verbinden\" und einmalig anmelden. „Trennen\" hebt die Kopplung auf.\n**Wirkung:** Telefonierst du, bekommst du keine Videoanrufe; nimmst du einen Videoanruf an, wird in Teams/Webex „Bitte nicht stören\" gesetzt und am Ende zurückgenommen.\n**Gut zu wissen:** Ob und wie das bei euch verfügbar ist, legt dein Mandant fest (siehe „Bei {Mandant}\").\n\n**Hinweis:** Die Kopplung arbeitet best-effort. Die Richtung **Video → Telefon** (automatisches „Bitte nicht stören\" in Webex) setzt eine **Webex-Calling-Organisation** voraus. Nutzt eure Telefonie BroadWorks/Cloud-PBX, kann dieser Schritt entfallen — die Richtung **Telefon → Video** funktioniert dennoch. Im Zweifel wende dich an deinen Admin."
  },
  {
    "id": "HA-36",
    "slug": "companion",
    "category": "Companion",
    "title": "Was ist der Companion?",
    "keywords": [
      "companion",
      "terminal server",
      "ablage",
      "zweite sitzung",
      "lokal"
    ],
    "relates": [
      "CO-01",
      "CO-02",
      "H-04"
    ],
    "related": [
      "HA-23",
      "HA-32"
    ],
    "body": "**Kurz:** Der Companion ist eine **zweite, tonlose/bildlose Sitzung** von dir auf einem Terminal-Server. Er übernimmt die **lokale Ablage** (Aufzeichnung, Scans, Unterschriften, NFC).\n**So geht's:** Du musst nichts Besonderes tun — ist der Companion verbunden (Chip oben), läuft die Ablage automatisch über ihn.\n**Gut zu wissen:** Audio/Video deines Gesprächs laufen weiterhin über dein normales Beratergerät; der Companion ist nur für die Datenablage zuständig."
  }
];

export function getArticle(slug: string): HelpArticle | null {
  return HELP_ARTICLES.find((a) => a.slug === slug) ?? null;
}

export function helpCategories(): string[] {
  const out: string[] = [];
  for (const a of HELP_ARTICLES) if (!out.includes(a.category)) out.push(a.category);
  return out;
}

export function searchHelp(query: string, limit = 8): HelpArticle[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const scored = HELP_ARTICLES.map((a) => {
    let s = 0;
    if (a.title.toLowerCase().includes(q)) s += 10;
    if (a.keywords.some((k) => k.toLowerCase().includes(q))) s += 6;
    if (a.body.toLowerCase().includes(q)) s += 2;
    return { a, s };
  }).filter((x) => x.s > 0).sort((x, y) => y.s - x.s);
  return scored.slice(0, limit).map((x) => x.a);
}
